// Modal Event Handlers

document.addEventListener("DOMContentLoaded", () => {
  const MIX_TYPE_MODAL_ID = "mixTypeWarningModal";
  const mixTypeWarning = document.getElementById(MIX_TYPE_MODAL_ID);
  const cartButton = document.getElementById("cart-icon-bubble");
  const cancelButton = document.querySelector(".modal-button.cancel-button");

  const handleModalEvent = async (isConfirmed, id, source) => {
    if (source === "overlay") {
      window.OpusNoATC = true;
      localStorage.removeItem("savedSelectedProducts");
      if (mixTypeWarning) {
        mixTypeWarning.style.display = "none";
      }
      return;
    }

    switch (id) {
      case MIX_TYPE_MODAL_ID:
        await mixTypeHandle(isConfirmed);
        break;
    }
  };

  window.addEventListener("info-modal:confirm", (e) => {
    handleModalEvent(true, e.detail.id, e.detail.source);
  });

  window.addEventListener("info-modal:cancel", (e) => {
    handleModalEvent(false, e.detail.id, e.detail.source);
  });
  const mixTypeHandle = async (isConfirmed) => {
    if (isConfirmed) {
      localStorage.removeItem("savedSelectedProducts");
      window.location.href = "/cart";
      return;
    }
    const normalCancelText = cancelButton.innerText;
    cancelButton.innerText = window.subscriptionModalText.loading;
    //  clear cart then re-added saved products to cart
    try {
      const response = await fetch("/cart/clear", { method: "POST" });
      if (!response.ok) {
        console.error("Failed to clear cart");
        return;
      }

      await new Promise((resolve) => setTimeout(resolve, 100));

      let cartEmpty = false;
      let retries = 0;
      while (!cartEmpty && retries < 5) {
        const cartCheck = await fetch("/cart.js").then((r) => r.json());
        if (cartCheck.items.length === 0) {
          cartEmpty = true;
        } else {
          await new Promise((resolve) => setTimeout(resolve, 100));
          retries++;
        }
      }

      if (!cartEmpty) {
        console.error("Cart could not be cleared");
        return;
      }

      const selectedProducts = localStorage.getItem("savedSelectedProducts");
      if (selectedProducts) {
        const products = JSON.parse(selectedProducts);
        for (const product of products) {
          await addProductToCart(
            product.id,
            product.quantity || 1,
            product.selling_plan
          );
        }
        localStorage.removeItem("savedSelectedProducts");
      }
      // open mini-cart
      if (cartButton) cartButton.click();
    } catch (error) {
      console.error("Error handle mixtype :", error);
      return;
    } finally {
      mixTypeWarning.style.display = "none";
      window.OpusNoATC = false;
      cancelButton.innerText = normalCancelText;
    }
  };
});

const addProductToCart = async (variantId, quantity, sellingPlanId = null) => {
  const formData = new FormData();
  formData.append("id", variantId);
  formData.append("quantity", quantity);
  if (sellingPlanId) formData.append("selling_plan", sellingPlanId);
  const response = await fetch("/cart/add.js", {
    method: "POST",
    body: formData,
  });
  if (!response.ok) throw new Error("Failed to add product to cart");
  return await response.json();
};

// Custom Add to Cart Logic
(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const MIX_TYPE_MODAL_ID = "mixTypeWarningModal";
    const mixTypeWarning = document.getElementById(MIX_TYPE_MODAL_ID);
    const originalFetch = window.fetch;
    const originalXHROpen = XMLHttpRequest.prototype.open;

    const fire = (name, detail = {}) =>
      window.dispatchEvent(new CustomEvent(name, { detail }));

    const hasSubscription = (cart) =>
      cart.items?.some((item) => !!item.selling_plan_allocation);

    const getSubscriptionPlanIds = (cart) =>
      cart.items
        .filter((item) => item.selling_plan_allocation)
        .map((item) => item.selling_plan_allocation.selling_plan.id);

    const toggleMixTypeWarning = (show) => {
      mixTypeWarning.style.display = show ? "flex" : "none";
    };

    const savedCurrentSelectedProducts = (products) => {
      if (!products || products.length === 0) return;

      const existing = localStorage.getItem("savedSelectedProducts");
      let storedProducts = [];

      if (existing) {
        try {
          storedProducts = JSON.parse(existing);
        } catch (e) {
          console.warn("Failed to parse savedSelectedProducts:", e);
          storedProducts = [];
        }
      }

      // convert everything to string
      const normalizedStored = storedProducts.map((p) => ({
        ...p,
        id: String(p.id),
        selling_plan: p.selling_plan ? String(p.selling_plan) : null,
      }));

      const normalizedNew = products.map((p) => ({
        ...p,
        id: String(p.id),
        selling_plan: p.selling_plan ? String(p.selling_plan) : null,
      }));

      const merged = [
        ...normalizedStored,
        ...normalizedNew.filter(
          (p) =>
            !normalizedStored.some(
              (sp) => sp.id === p.id && sp.selling_plan === p.selling_plan
            )
        ),
      ];

      localStorage.setItem("savedSelectedProducts", JSON.stringify(merged));
    };

    window.fetch = async function (...args) {
      const [url, options] = args;

      const urlString = typeof url === 'string' ? url : url.toString();

      if (urlString.includes("/cart/add")) {
        let productData = {};
        let oldCart = null;

        try {
          oldCart = await originalFetch("/cart.js").then((r) => r.json());
          if (options?.body instanceof FormData) {
            productData = Object.fromEntries(options.body.entries());
          } else if (typeof options?.body === "string") {
            productData = JSON.parse(options.body);
          }
          const addingIsSubscription = (() => {
            if (Array.isArray(productData.items)) {
              return productData.items.some((item) => !!item.selling_plan);
            }
            return !!productData.selling_plan;
          })();

          const cartHasSubscription = hasSubscription(oldCart);
          const selectedProducts = Array.isArray(productData.items)
            ? productData.items
            : [productData];
          if (cartHasSubscription && !addingIsSubscription) {
            console.warn(
              "Cannot add non-subscription item when cart has subscription items"
            );

            savedCurrentSelectedProducts(selectedProducts);
            toggleMixTypeWarning(true);
            window.OpusNoATC = false;
            const error = new Error(
              "Mixing subscription and one-time items not allowed"
            );
            error.isMixTypeError = true;
            return Promise.reject(error);
          }
          //  adding a subscription item when cart has non-subscription items
          if (
            !cartHasSubscription &&
            addingIsSubscription &&
            oldCart.items.length > 0
          ) {
            console.warn(
              "Cannot add subscription item when cart has non-subscription items"
            );
            savedCurrentSelectedProducts(selectedProducts);
            toggleMixTypeWarning(true);
            window.OpusNoATC = false;
            const error = new Error(
              "Mixing subscription and one-time items not allowed"
            );
            error.isMixTypeError = true;
            return Promise.reject(error);
          }
        } catch (err) {
          console.warn("Failed to fetch old cart:", err);
        } finally {
          window.OpusNoATC = false;
        }

        fire("cart:add", { oldCart, product: productData });
      }

      const response = await originalFetch.apply(this, args);

      if (
        urlString.includes("/cart/add") ||
        urlString.includes("/cart/change") ||
        urlString.includes("/cart/update")
      ) {
        try {
          const updatedCart = await fetch("/cart.js").then((r) => r.json());
          fire("cart:changed", { cart: updatedCart });
        } catch (e) {
          console.warn("Failed to fetch updated cart:", e);
        }
      }

      return response;
    };

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      if (url.includes("/cart/add")) {
        this.addEventListener("loadstart", async () => {
          try {
            const oldCart = await fetch("/cart.js").then((r) => r.json());
            fire("cart:add", { oldCart, via: "xhr" });
          } catch (err) {
            console.warn("Failed to fetch old cart (XHR):", err);
          }
        });
        this.addEventListener("load", async () => {
          try {
            const updatedCart = await fetch("/cart.js").then((r) => r.json());
            fire("cart:changed", { cart: updatedCart });
          } catch {}
        });
      }
      return originalXHROpen.call(this, method, url, ...rest);
    };
  });
})();

window.addEventListener("cart:add", (e) => {
  console.log("Cart before add:", e.detail.oldCart);
  console.log("Product being C:", e.detail.product);
});

window.addEventListener("cart:changed", (e) => {
  console.log("Cart changed!", e.detail.cart);
});
